// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"408":"a6ab176e","463":"64fdb30a","583":"05be4e3a","845":"1d16929a"}[chunkId] + ".chunk.js";
};